// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSettingActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { compose, withProps, withHandlers } from 'recompose';
import ColorPaletteSelection from './Izenda.ColorPaletteSelection';
import { curry, isUndefined } from 'lodash/fp';
import ColorPaletteStore from 'logic/Izenda.ColorPaletteStore';

/**
 * Show Color Palette Selection Pop-up
 * @param {Object} props
 * @param {Object} e
 */
function showColorPaletteSelectionPopup(props: any, e: any) {
  const {
    selectionPopupTitle,
    store,
    store: { palettes, currentColorPalette },
    onChange,
    displaySettingStatus,
    updateSelectedPalette
  } = props;

  props.openPopup(ColorPaletteSelection, {
    palettes,
    store: store,
    title: selectionPopupTitle,
    selectedPaletteName: currentColorPalette,
    onChange: onChange,
    displaySettingStatus: displaySettingStatus,
    updateSelectedPalette: updateSelectedPalette
  });
}

/**
 * Reset to default value if needed
 * @param {Object} props
 * @param {Object} e
 */
function resetDefaultValue(props: any, e: any) {
  const { store, updateSelectedPalette, onChange } = props;
  store.updateOriginalPalette(store.defaultColorPalette);

  updateSelectedPalette && updateSelectedPalette(store.defaultColorPalette);
  onChange &&
    onChange({
      value: {
        colorPalette: store.defaultColorPalette,
        isDefaultTheme: true
      }
    });
}

/**
 * Initial store
 * @param {Object} props
 */
async function init(props: any) {
  const {
    store,
    needMaskDefault,
    selectedPaletteName,
    defaultColorThemeLabel,
    value = {}
  } = props;
  const paletteName = isUndefined(selectedPaletteName) ? value.colorPalette : selectedPaletteName;

  await store.init(paletteName, needMaskDefault, defaultColorThemeLabel);
}

export default compose(
  withProps({
    store: new ColorPaletteStore(),
    init: init
  }),
  withHandlers({
    showColorPaletteSelectionPopup: curry(showColorPaletteSelectionPopup),
    resetDefaultValue: curry(resetDefaultValue)
  })
);



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorPalette/Izenda.ColorPaletteSettingActions.js